import { mensajeDeError } from 'src/utils'

import { createSlice } from '@reduxjs/toolkit'

export const messagesSlice = createSlice({
  name: 'messages',
  initialState: {
    value: null,
  },
  reducers: {
    pushError: (state, action) => {
      // Acepta un texto o el error tal cual (RTK Query, excepción…): el texto lo saca
      // mensajeDeError, así ninguna pantalla pierde el mensaje del servidor.
      const body = mensajeDeError(action.payload) || 'An error occurred, please try again later'
      state.value = {
        body,
        color: 'danger',
      }
    },
    pushInfo: (state, action) => {
      state.value = {
        body: action.payload,
        color: 'info',
      }
    },
    pushSuccess: (state, action) => {
      state.value = {
        body: action.payload,
        color: 'success',
      }
    },
    pushWarning: (state, action) => {
      state.value = {
        body: action.payload,
        color: 'warning',
      }
    },
  },
})

export const { pushError, pushInfo, pushSuccess, pushWarning } = messagesSlice.actions

export const selectMessage = (state) => state.messages.value

export default messagesSlice.reducer
